import React, { useEffect, useState } from "react";
import  "../Dashboard/Dashboard_Card.css"
// import course from '../Course Categories/CCComponents/All Courses/AllCourseData'
import course from './assets/courses.json'

const Skill_Card = () => {
  return (
    <>
    <div className="skill-wrapper">
	<div className="skill-card">
		<div className="skill-poster"><img src={course[0].imgURL} alt="Location Unknown" /></div>
		<div className="skill-details">
			<h1>{course[0].title}</h1>
			{/* <h2>2021 • PG • 1hr 38min</h2> */}
			<div className="skill-rating">
				<span>{course[0].rating} / 5</span>
				<i className="fas fa-star"></i>

				{/* <i className="far fa-star"></i> */}
			</div>
			<div className="skill-tags">
				<span className="skill-tag">{course[0].description}</span>
				
			</div>
			<div className="skill-cast">
				<a className="skill-desc" target="_block" href={course[0].courseURL} style={{ textDecoration: "none" }}>Explore The Course</a>
			</div>
		</div>
	</div>
	<div className="skill-card">
		<div className="skill-poster"><img src={course[4].imgURL} alt="Location Unknown" /></div>
		<div className="skill-details">
			<h1>{course[4].title}</h1>
			{/* <h2>2021 • PG • 1hr 38min</h2> */}
			<div className="skill-rating">
				<span>{course[4].rating} / 5</span>
				<i className="fas fa-star"></i>

				{/* <i className="far fa-star"></i> */}
			</div>
			<div className="skill-tags">
				<span className="skill-tag">{course[4].description}</span>
				
			</div>
			<div className="skill-cast">
				<a className="skill-desc" target="_block" href={course[4].courseURL} style={{ textDecoration: "none" }}>Explore The Course</a>
			</div>
		</div>
	</div>
	<div className="skill-card">
		<div className="skill-poster"><img src={course[2].imgURL} alt="Location Unknown" /></div>
		<div className="skill-details">
			<h1>{course[2].title}</h1>
			{/* <h2>2021 • PG • 1hr 38min</h2> */}
			<div className="skill-rating">
				<span>{course[2].rating} / 5</span>
				<i className="fas fa-star"></i>

				{/* <i className="far fa-star"></i> */}
			</div>
			<div className="skill-tags">
				<span className="skill-tag">{course[2].description}</span>
				
			</div>
			<div className="skill-cast">
				<a className="skill-desc" target="_block" href={course[2].courseURL} style={{ textDecoration: "none" }}>Explore The Course</a>
			</div>
		</div>
	</div>
	
	</div>
    </>
  )
}

export default Skill_Card